module.exports = __webpack_public_path__ + "static/media/icon_email.2753a3db.svg";